<template>
  <mds-fieldset
    v-if="isVariesStatus"
    horizontal
    size="small"
    :legend="labels.fieldLabel"
    :class="$style['varies-field-fieldset']"
  >
    <mds-input size="small" readonly hidden-label :value="labels.varies" :label="labels.fieldLabel">
    </mds-input>
    <mds-button
      size="small"
      type="button"
      variation="flat"
      :class="$style['varies-field-clear-button']"
      @click="handleClearVariesStatus"
    >
      {{ labels.clear }}
    </mds-button>
  </mds-fieldset>
  <hypo-number-input
    v-else
    size="small"
    is-percent
    :label="labels.fieldLabel"
    :class="$style['varies-field-input']"
    :hidden-label="false"
    :saved-value="fieldValue"
    :allow-leave-blank="allowLeaveBlank"
    :range="range"
    :placeholder="placeholder"
    @input-invalid="$emit('input-invalid')"
    @focus="$emit('focus', $event)"
    @blur="$emit('blur', $event)"
    @update-saved-value="handleFieldValueChanged"
  >
  </hypo-number-input>
</template>

<script>
import MdsFieldset from '@mds/fieldset';
import MdsInput from '@mds/input';
import { MdsButton } from '@mds/button';
import HypoNumberInput from 'hypo-shared-utils/src/components/HypoNumberInput';

export default {
  name: 'varies-field',
  components: {
    MdsFieldset,
    MdsButton,
    MdsInput,
    HypoNumberInput,
  },
  props: {
    isVaries: {
      type: Boolean,
    },
    value: {
      type: [Number, String],
    },
    defaultValue: {
      type: [Number, String],
    },
    range: {
      type: Object,
      default: () => {},
    },
    placeholder: {
      type: String,
      default: '',
    },
    allowLeaveBlank: {
      type: Boolean,
      default: true,
    },
    labels: {
      type: Object,
      default: () => {
        return {
          fieldLabel: '',
          varies: '',
          clear: 'Clear',
        };
      },
    },
  },
  data() {
    return {
      isVariesStatus: this.isVaries,
      fieldValue: this.value,
    };
  },
  watch: {
    isVaries() {
      this.isVariesStatus = this.isVaries;
    },
    value() {
      this.fieldValue = this.value;
    },
  },
  methods: {
    handleClearVariesStatus() {
      this.isVariesStatus = false;
      this.fieldValue = this.defaultValue;
      this.emitFieldUpdateEvent();
    },
    handleFieldValueChanged(fieldValue) {
      this.fieldValue = fieldValue;
      this.emitFieldUpdateEvent();
    },
    emitFieldUpdateEvent() {
      this.$emit('update-field', this.fieldValue);
    },
  },
};
</script>

<style lang="scss" module>
@import '~@mds/constants';
@import '~@mds/link';

.varies-field-fieldset {
  .varies-field-clear-button {
    flex: 0 0 30px;
    @include mds-link($in-table: true);
  }
}

.varies-field-input {
  margin-bottom: $mds-space-2-x;
}
</style>
